export const LABEL_KEY = 'label';

export const VALUE_KEY = 'key';

export const NEW_FORMAT_PLATE = 'T0';

export const OLD_FORMAT_PLATE = 'T2';

export const TEMPORARY_PLATE = 'Y';

export const NO_FILTER = '0000';

export const CAR_TYPE = 'A';

export const PLATE_TYPES = [
  {
    value: 'T0',
    label: 'TARGA ITALIANA NUOVO FORMATO',
  },
  {
    value: 'T1',
    label: 'TARGA ITALIANA SPECIALE',
  },
  {
    value: 'T2',
    label: 'TARGA ITALIANA VECCHIO FORMATO',
  },
  {
    value: 'X',
    label: 'TARGA PROVA',
  },
  {
    value: 'Y',
    label: 'TARGA PROVVISORIA',
  },
  {
    value: 'J',
    label: 'TARGA FILOBUS',
  },
  {
    value: 'L',
    label: 'TELAIO',
  },
  {
    value: 'E',
    label: 'TARGA ESTERA',
  },
  {
    value: 'C',
    label: 'CERTIFICATO IDONEITA’ TECNICA',
  },
];

export const VECHICLE_TYPES = [
  {
    value: '0000',
    label: 'NESSUN FILTRO',
  },
  {
    value: 'A',
    label: 'AUTOVETTURA',
  },
  {
    value: 'M',
    label: 'MOTOCICLO',
  },
  {
    value: 'W',
    label: 'CICLOMOTORE',
  },
  {
    value: 'C',
    label: 'AUTOCARRO',
  },
  {
    value: 'R',
    label: 'RIMORCHIO',
  },
  {
    value: 'Q',
    label: 'MOTOCARRO',
  },
  {
    value: 'B',
    label: 'AUTOBUS',
  },
  {
    value: 'T',
    label: 'MACCHINA OPERATRICE',
  },
  {
    value: 'S',
    label: 'MACCHINA AGRICOLA',
  }
];
